import { lazy } from "react";

export const WorkspaceProjectsView = lazy(
  () => import("./WorkspaceProjectsView"),
);

export const WorkspaceCreateProjectView = lazy(
  () => import("./WorkspaceCreateProjectView"),
);
